import TruckBaseController from '../common/truck.base.controller'
import AppConstants from '../../../config/app.constants';

class TruckCreateController extends TruckBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, TruckService, Modal, $translate, $stateParams, LocationService, VehicleLockerService, CommonLayoutService) {

		super(Auth, $state, User, TruckService, Modal, $translate, $stateParams)
		this.LocationService = LocationService;
		this.VehicleLockerService = VehicleLockerService;
		this.CommonLayoutService = CommonLayoutService;
		this.hasACL = {};
		this.defaultModel = {
			id: '',
			make: '',
			status: true,
			model: '',
			year: '',
			vinnum: '',
			platenum: '',
			branch: User.getUser().branchId,
			lockers: false,
			truckLockers: [],
			liability: false,
			liabilityLimit: null,
			truckLiability: false,
			NFCScan: false,
			NFCTagId: null,
			fuelType: 'UNLEADED'
		}
		this.model = angular.copy(this.defaultModel)
		this.locations = [];
		this.locationsToIgnore = [];
		this.offset = 0;
		this.changeOffsetFlag = false;
		this.loading = false;
		this.totalLocations = 0;
		this.locationData = [];
		this.isValid = true;
		this.isLoading = false;
		this.stateList = this.CommonLayoutService.locationStateMapping();
		this.fuelTypeList = this.CommonLayoutService.fuelTypeMapping();
	}

	$onInit() {
		this.Service.all(null, 0, 100)
			.then((trucks) => {
				return trucks.results.map((data) => data.locationId)
			})
			.then((locationsToIgnore) => {
				this.locationsToIgnore = locationsToIgnore;
				this.getAllLocation();
				// this.loadLockerLocations('', 0);
			})
	}

	// get all location
	getAllLocation() {
		this.Service.loadRemainingTrucks(this.model.branch, 'TRUCK')
			.then((res) => {
				this.totalRecord = res.length;
				const locations = this.mappingLocationData(res);
				this.locations = this.locations.concat(locations);
			})
			.catch((err) => {
				console.log(err);
			})
	}

	mappingLocationData(location) {
		return location.map((loc) => {
			return {
				Key: loc.id + " | " + loc.name,
				Value: loc.id,
				address: loc.address ? loc.address : '',
				city: loc.city ? loc.city : '',
				state: loc.state ? this.stateList[loc.state] : '',
				zip: loc.zip ? loc.zip : ''
			}
		});
	}

	reset() {
		this.model = angular.copy(this.defaultModel);
		this.model.truckLockers = [];
		this.clearErrors();
	}

	submit(evt) {
		this.loading = true;
		this.Service.create({
			id: this.model.id,
			locationId: this.model.locationId.Value,
			make: this.model.make,
			model: this.model.model,
			year: this.model.year,
			vinnum: this.model.vinnum,
			platenum: this.model.platenum,
			status: this.model.status,
			lockers: this.model.lockers,
			truckLockers: this.model.truckLockers.map((info) => {
				if (this.model.liability) info.maxShipment = null;
				else info.maxLiability = null;
				return info;
			}),
			liability: this.model.liability,
			liabilityLimit: this.model.liabilityLimit,
			truckLiability: this.model.truckLiability,
			NFCScan: this.model.NFCScan,
			NFCTagId: this.model.NFCScan ? this.model.NFCTagId : null,
			fuelType: this.model.fuelType
		}, this.model.branch)
			.then((data) => {
				this.loading = false
				this.askCreate()
			})
			.then(() => {
				this.locations = [];
				this.getAllLocation();
			})
			.catch((err) => {
				this.loading = false
				const errorPath = err && err.data && err.data.errors && err.data.errors[0].path;

				if (errorPath === 'VEHICLE.NFCTagId') {
					this.errorMessage = this.$translate.instant('common.unique_nfc_tag_id');
				}
				else if (err && err.data && err.data.message) {
					this.errorMessage += err.data.message + '<br/>'
				}
				else{
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				}
			})
	}

	locationSearchObj(searchKey) {
		searchKey = searchKey || '';
		const searchObj = {
			queryJSON: {
				rules: [{
					field: 'branchId',
					condition: '=',
					data: this.model.branch
				},
				{
					field: 'locationType',
					condition: '=',
					data: 'LOCKER'
				},
				{
					group: {
						rules: [{
							field: 'id',
							condition: 'like',
							data: '%' + searchKey + '%'
						},
						{
							field: 'name',
							condition: 'like',
							data: '%' + searchKey + '%'
						}
						],
						operator: 'OR'
					}
				}
				],
				operator: 'AND'
			}
		};
		return searchObj.queryJSON.rules.length ? searchObj : null;
	}

	loadLockerLocations(searchKey, offset) {
		// var searchObj = this.locationSearchObj(searchKey);
		searchKey = searchKey || null;

		return this.VehicleLockerService.getLockerLocations(null, searchKey, this.model.branch, AppConstants.defaultPageLimit, offset)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.totalLocations = data.total;
					this.locationData = this.locationMap(data.results);
				} else {
					const loc = this.locationMap(data.results);
					this.locationData = this.locationData.concat(loc);
				}
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					this.errorMessage = err.data.message;
				}
			})
	}

	locationMap(locations) {
		return locations.map((obj) => {
			return {
				Key: obj.locationId + ' | ' + obj.locationName,
				Value: obj.locationId
			}
		});
	}

	addTruckLockers(searchKey, offset) {
		// var searchObj = this.locationSearchObj('');
		searchKey = searchKey || null;
		this.isLoading = true;

		this.VehicleLockerService.getLockerLocations(null, searchKey, this.model.branch, AppConstants.defaultPageLimit, offset)
			.then((data) => {
				this.totalLocations = data.total;
				this.locationData = this.locationMap(data.results);
				this.model.truckLockers.push({
					label: null,
					maxShipment: 1,
					maxLiability: null,
					location: null,
					locationId: null,
					isDuplicate: false
				});
				if (this.model.truckLockers.length > 1) {
					this.validateLocker();
				}
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					this.errorMessage = err.data.message;
				}
			})
			.finally(() => {
				this.isLoading = false;
			})
	}

	removeLockers(index) {
		this.model.truckLockers.splice(index, 1);
		this.validateLocker();
	}

	validateLocker() {
		this.model.truckLockers = _.map(this.model.truckLockers, (obj, index) => {
			obj.isDuplicate = false;
			obj.locationId = obj.location ? obj.location.Value : null;
			let match = _.find(this.model.truckLockers, (compairObject, compairObjIndex) => {
				compairObject.locationId = compairObject.location ? compairObject.location.Value : null;
				if (index > compairObjIndex) return compairObject.locationId == obj.locationId;
			});
			if (match) {
				obj.isDuplicate = true;
				return obj;
			} else {
				return obj;
			}
		});
		let isValidDirective = this.model.truckLockers.map((obj) => {
			if (obj.isDuplicate) return true;
		})
		this.isValid = isValidDirective.indexOf(true) >= 0 ? false : true;
	}

	resetLockers() {
		if (!this.model.lockers) this.model.truckLockers = [];
	}

	validateLiability() {
		if (!this.model.truckLiability || !this.model.liability) return;
		
		let lockerLiability = 0;
		this.isLiabilityExceed = false;
		this.liabilityError;

		this.model.truckLockers.forEach((locker, index) => {
			lockerLiability += locker.maxLiability;
		})
		if (this.model.liabilityLimit && (lockerLiability > this.model.liabilityLimit)) {
			this.isLiabilityExceed = true;
			this.liabilityError = this.$translate.instant('truck.liability_error');
		}
		else {
			this.isLiabilityExceed = false;
			delete this.liabilityError;
		}
	}

	resetLiability() {
		if (!this.model.truckLiability) this.model.liabilityLimit = null;
	}

	setVehicleId() {
		if (this.model.locationId) { 
			this.model.id = this.model.locationId.Value;
		}
		else {
			this.model.id = null;
		}
	}
}

export default TruckCreateController;


// WEBPACK FOOTER //
// ./client/app/components/truck/create/truck.create.controller.js